module.exports = __webpack_public_path__ + "img/44_ProLabel_PA66.eb21524b.png";